// React
import { useContext, useEffect, useMemo, useReducer, useState } from "react";

// Components
import { Card, Collapse, Grid, Icon, MenuItem, Select, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";

// Data

import { MessageManager } from "context";
// import { UserContext } from "context/user";
import { gql, NetworkStatus, useApolloClient, useMutation, useQuery } from "@apollo/client";
import CartelError from "components/Carteles/Error";
import Loading from "components/Carteles/Loading";
import SinDatos from "components/Carteles/SinDatos";
import GeneralLayout from "components/LayoutContainers/GeneralLayout";
import CustomPagination from "components/Pagination";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import DataTable from "components/Tables/DataTable";
import { ConfirmarContext } from "context/ConfirmarContext";
import { MenuContext } from "context/menuContext";
import dataProductos from "./data/dataProductos";
import ModalCategorias from "./ModalCategorias";
import ModalCombo from "./ModalCombo";
import ModalFotos from "./ModalFotos";
import ModalMenuDelDia from "./ModalMenuDelDia";
import ModalProducto from "./ModalProducto";
import { getUproColor } from "utils/colors";
import ModalInformacionNutricional from "./ModalInformacionNutricional";
import ModalHistorialControlCalidad from "./ModalHistorialControlCalidad";
import ModalOrdenesTrabajo from "./ModalOrdenesTrabajo";
import ModalDescuentos from "./ModalDescuentos";
import ModalProductoComercial from "./ModalComerciales";
import ModalValoraciones from "./ModalValoraciones";
import ModalNewProducto from "./ModalNewProducto";
import ModalAreas from "./ModalAreas";
import ModalComanderas from "./ModalComanderas";
import { UserContext } from "context/user";

const GET_PRODUCTOS = gql`
  query getProductos(
    $pagination: PaginationInput
    $order: Order
    $search: String
    $filter: JSON
    $sinIngredientes: Boolean
    $materiaPrimaDeshabilitada: Boolean
  ) {
    paginationInfo {
      pages
      total
    }
    productos(
      pagination: $pagination
      order: $order
      search: $search
      filter: $filter
      sinIngredientes: $sinIngredientes
      materiaPrimaDeshabilitada: $materiaPrimaDeshabilitada
    ) {
      id
      nombre
      disponibilidad
      precioCarta
      precioOnline
      precioCosto
      precioPorMayor
      precioPorMayorOnline
      esElaborado
      esIngrediente
      cantidadPorciones
      cantidadPorMayor
      descripcion
      combo
      seccion
      comanderas {
        id
        printName
        habilitado
        estadoConexion
      }
      lugarVenta
      valoracionPromedio
      tipoProducto {
        id
        tipo
      }
      categoriaProducto {
        id
        categoria
      }
      area {
        id
        nombre
      }
      ingredientes {
        id
        cantidad
        materiaPrima {
          id
          nombre
          precio
          porcentajeUtilizable
          disabled
          tipoUnidad {
            id
            nombre
            abreviatura
            multiplicador
          }
        }
        tipoUnidad {
          id
          nombre
          abreviatura
          multiplicador
        }
      }
      descartables {
        id
        cantidad
        materiaPrima {
          id
          nombre
          precio
          disabled
          tipoUnidad {
            id
            nombre
            abreviatura
            multiplicador
          }
        }
        tipoUnidad {
          id
          nombre
          abreviatura
          multiplicador
        }
      }
      files {
        id
        file
      }
      productosCombo {
        id
        nombre
      }
    }
  }
`;
const reducer = (state, action) => {
	switch (action.type) {
		case "categoria":
			return {
				...state,
				categoria: action.payload,
			};
		case "disponibilidad":
			if (action.payload === "INGREDIENTE") {
				return {
					...state,
					disponibilidad: action.payload,
					esIngrediente: true,
					errorReceta: false,
					sinIngredientes: false,
				};
			} else if (action.payload === "ERROR_RECETA") {
				return {
					...state,
					disponibilidad: action.payload,
					esIngrediente: false,
					errorReceta: true,
					sinIngredientes: false,
				};
			} else if (action.payload === "SIN_INGREDIENTES") {
				return {
					...state,
					disponibilidad: action.payload,
					esIngrediente: false,
					errorReceta: false,
					sinIngredientes: true,
				};
			} else {
				return {
					...state,
					disponibilidad: action.payload,
					esIngrediente: false,
					errorReceta: false,
					sinIngredientes: false,
				};
			}
		default:
			return state;
	}
};

function Productos() {
	const client = useApolloClient();
	const [search, setSearch] = useState("");
	const [searchTimeout, setSearchTimeout] = useState(null);
	const [page, setPage] = useState(1);
	const [loadingExport, setLoadingExport] = useState(false);
	const [modalAddProducto, setModalAddProducto] = useState(false);
	const [pagesInfo, setPagesInfo] = useState({
		pages: 0,
		total: 0,
	});
	const [orderBy, setOrderBy] = useState({
		campo: "id",
		orden: "DESC",
	});
	const [selectedProducto, setSelectedProducto] = useState(null);
	const [categorias, setCategorias] = useState([]);
	const [tiposProducto, setTiposProducto] = useState([]);
	const [filtro, setFiltro] = useReducer(reducer, {
		categoria: 0,
		disponibilidad: "DISPONIBLE",
		esIngrediente: false,
		errorReceta: false,
		sinIngredientes: false,
	});
	const { menu } = useContext(MenuContext);
	const [openFiltros, setOpenFiltros] = useState(true);

	//Modal
	const [modalProducto, setModalProducto] = useState(false);
	const [modalCombo, setModalCombo] = useState(false);
	const [modalFotos, setModalFotos] = useState(false);
	// const [modalMenu, setModalMenu] = useState(false);
	const [modalCategorias, setModalCategorias] = useState(false);
	const [modalOT, setModalOT] = useState(false);
	const [openInformacionNutricional, setOpenInformacionNutricional] = useState(false);
	const [openControlCalidadHistory, setOpenControlCalidadHistory] = useState(false);
	// const [openDescuentos, setOpenDescuentos] = useState(false);
	const [openModalValoraciones, setOpenModalValoraciones] = useState(false);
	const [optionsCreate, setOptionsCreate] = useState({});
	const { handleSnackbar } = useContext(MessageManager);
	const { verificarAcceso } = useContext(UserContext);
	const { confirmar } = useContext(ConfirmarContext);
	//Modal Areas
	const [modalAreas, setModalAreas] = useState(false);
	const [modalComanderas, setModalComanderas] = useState(false);

	const { columns, getRows } = dataProductos;

	const handleOrderBy = (campo) => {
		if (orderBy.campo === campo) {
			if (orderBy.orden === "ASC") {
				setOrderBy({
					campo: campo,
					orden: "DESC",
				});
			} else {
				setOrderBy({
					campo: campo,
					orden: "ASC",
				});
			}
		} else {
			setOrderBy({
				campo: campo,
				orden: "ASC",
			});
		}
	};
	const handleSearch = (event) => {
		const newTimeout = setTimeout(() => {
			setSearch(event.target.value);
			setPage(1);
		}, 500);
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}
		setSearchTimeout(newTimeout);
	};

	const variablesFiltroProductos = useMemo(
		() => ({
			search: search || null,
			order: { field: orderBy.campo, order: orderBy.orden },
			filter: {
				idCategoria: filtro.categoria == 0 ? undefined : filtro.categoria,
				esIngrediente: filtro.disponibilidad === "INGREDIENTE" ? true : false,
				disponibilidad:
					filtro.disponibilidad === "TODOS" ||
						filtro.disponibilidad === "INGREDIENTE" ||
						filtro.disponibilidad === "ERROR_RECETA"
						? undefined
						: filtro.disponibilidad === "DISPONIBLE"
							? 1
							: filtro.disponibilidad === "NO_DISPONIBLE"
								? 0
								: undefined,
			},
			sinIngredientes: filtro.disponibilidad === "SIN_INGREDIENTES" ? true : false,
			materiaPrimaDeshabilitada: filtro.disponibilidad === "ERROR_RECETA" ? true : false,
		}),
		[search, orderBy.campo, orderBy.orden, filtro]
	);

	const { loading, error, data, refetch, networkStatus } = useQuery(
		GET_PRODUCTOS,
		{
			variables: {
				...variablesFiltroProductos,
				pagination: { page: page, limit: 20 },
			},
			fetchPolicy: "network-only",
			notifyOnNetworkStatusChange: true,
		}
	);
	const { data: dataCategorias, refetch: refetchCategorias } = useQuery(
		gql`
      query categoriasProducto {
        categoriasProducto {
          id
          categoria
        }
      }
    `,
		{
			fetchPolicy: "network-only",
		}
	);
	const { data: dataTipos, refetch: refetchTipos } = useQuery(
		gql`
      query tiposProducto {
        tiposProducto {
          id
          tipo
        }
      }
    `,
		{
			fetchPolicy: "network-only",
		}
	);
	const [deleteProducto, { loading: loadingdeleteProducto }] = useMutation(
		gql`
      mutation deleteProducto($id: ID!) {
        deleteProducto(id: $id) {
          id
        }
      }
    `
	);
	const [saveProducto, { loading: loadingMutation }] = useMutation(
		gql`
      mutation saveProducto($input: ProductoInput!) {
        saveProducto(input: $input) {
          id
        }
      }
    `
	);
	const ejecutarAccionUsuario = (accion, item) => {
		switch (accion) {
			case "editar":
				setModalProducto(true);
				setSelectedProducto(item);
				break;
			case "editarCombo":
				setModalCombo(true);
				setSelectedProducto(item);
				break;
			case "borrar":
				if (!loadingdeleteProducto) {
					confirmar({
						title: "Advertencia",
						message: `¿Está seguro que desea eliminar el producto ${item.nombre || item.combo
							}? Esta acción no se puede deshacer.`,
						icon: "warning",
						func: () => {
							deleteProducto({ variables: { id: item.id } })
								.then(() => {
									handleSnackbar("Borrado correctamente", "success");
									refetch();
								})
								.catch(() => {
									handleSnackbar("Ha ocurrido un error al borrar", "error");
								});
						},
					});
				}
				break;
			case "disponible":
				saveProducto({
					variables: {
						input: {
							id: item.id,
							disponibilidad: true,
						},
					},
				})
					.then(() => {
						handleSnackbar("Actualizado correctamente", "success");
						refetch();
					})
					.catch(() => {
						handleSnackbar("Error al actualizar", "error");
					});
				break;
			case "noDisponible":
				saveProducto({
					variables: {
						input: {
							id: item.id,
							disponibilidad: false,
						},
					},
				})
					.then(() => {
						handleSnackbar("Actualizado correctamente", "success");
						refetch();
					})
					.catch(() => {
						handleSnackbar("Error al actualizar", "error");
					});
				break;
			case "fotos":
				setModalFotos(true);
				setSelectedProducto(item);
				break;
			default:
				break;
		}
	};

	const calcularValoresIngrediente = (ingrediente) => {
		if (!ingrediente)
			return {
				valorUtilizable: 0,
				cantidadUtilizable: 0,
				precioUtilizable: 0,
				porcentajeUtilizable: 0,
			};
		let cantidadIngresada = parseFloat(ingrediente.cantidad) || 0;
		let porcentajeUtilizable = parseFloat(ingrediente.materiaPrima?.porcentajeUtilizable) || 100;
		let precioPorUnidad = parseFloat(ingrediente.materiaPrima?.precio) || 0;

		let unidadCantidad = ingrediente.tipoUnidad;
		let unidadPrecio = ingrediente.tipoUnidadOrigen || unidadCantidad;

		let multiplicadorCantidad = parseFloat(unidadCantidad?.multiplicador) || 1;
		let multiplicadorPrecio =
			parseFloat(ingrediente?.materiaPrima?.tipoUnidad?.multiplicador) ||
			unidadPrecio?.multiplicador ||
			1;
		let cantidadNecesaria = cantidadIngresada / (porcentajeUtilizable / 100);
		let cantidadConvertida = (cantidadNecesaria * multiplicadorCantidad) / multiplicadorPrecio;
		let precioUtilizable = cantidadConvertida * precioPorUnidad;

		return {
			valorUtilizable: cantidadNecesaria,
			cantidadUtilizable: cantidadNecesaria,
			precioUtilizable: precioUtilizable,
			porcentajeUtilizable: porcentajeUtilizable,
		};
	};

	function descargarReceta(item) {
		const { nombre: nombreProducto, ingredientes } = item;

		let listadoExistente = ingredientes.map((ingrediente) => {
			let valoresCalculados = calcularValoresIngrediente(ingrediente);

			return {
				cantidad: ingrediente.cantidad,
				nombre: ingrediente.materiaPrima.nombre,
				idTipoUnidad: ingrediente.tipoUnidad.id,
				idMateriaPrima: ingrediente.materiaPrima.id,
				tipoUnidad: ingrediente.tipoUnidad,
				tipoUnidadOrigen: ingrediente.materiaPrima?.tipoUnidad,
				precio: ingrediente.materiaPrima?.precio,
				idExistente: ingrediente.id,
				disabled: ingrediente.materiaPrima.disabled,
				...valoresCalculados,
			};
		});

		const XLSX = require("xlsx");

		const ws_data = [];

		ws_data.push([null, null, null, null, null, null, null, null, null]);
		ws_data[0][1] = `Porducto: ${nombreProducto}`;

		ws_data.push([]);

		ws_data.push([]);
		ws_data[2][0] = "Ingredientes:";

		ws_data.push([]);

		ws_data.push([
			"Nombre",
			"Precio por unidad",
			"unidad",
			"Costo",
			"Cantidad neta",
			"unidad",
			"Rendimiento",
			"Cantidad bruta necesatia",
			"Precio cantidad necesaria",
		]);

		listadoExistente.forEach((ing) => {
			ws_data.push([
				ing.nombre,
				ing.precio,
				ing.tipoUnidadOrigen?.abreviatura,
				{
					t: "n",
					v:
						ing.precio *
						(ing.cantidad /
							(ing.tipoUnidadOrigen?.id !== ing.tipoUnidad?.id
								? ing.tipoUnidadOrigen?.multiplicador
								: 1)),
					z: '"$"#,##0',
				},
				ing.cantidad,
				ing.tipoUnidad?.abreviatura,
				{ t: "n", v: ing.porcentajeUtilizable / 100, z: "0%" },
				ing.cantidadUtilizable,
				{ t: "n", v: ing.precioUtilizable, z: '"$"#,##0' },
			]);
		});

		const ws = XLSX.utils.aoa_to_sheet(ws_data);

		ws["!merges"] = [{ s: { r: 0, c: 1 }, e: { r: 0, c: 8 } }];

		ws["B1"].s = {
			font: { name: "Calibri", sz: 16, bold: true },
			alignment: { horizontal: "center" },
		};
		ws["A3"].s = {
			font: { name: "Calibri", sz: 12, bold: true },
		};
		for (let col = 0; col < 9; col++) {
			const cell = XLSX.utils.encode_cell({ r: 4, c: col });
			if (!ws[cell]) continue;
			ws[cell].s = {
				font: { name: "Calibri", bold: true },
				fill: { fgColor: { rgb: "D9E1F2" } },
				alignment: { horizontal: "center" },
			};
		}

		ws["!cols"] = [
			{ wch: 25 },
			{ wch: 20 },
			{ wch: 12 },
			{ wch: 18 },
			{ wch: 12 },
			{ wch: 22 },
			{ wch: 22 },
			{ wch: 22 },
			{ wch: 22 },
		];

		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Hoja1");
		XLSX.writeFile(wb, `Receta ${nombreProducto}.xlsx`);
	}

	const getDisponibilidadLabel = (value) => {
		const labels = {
			DISPONIBLE: "Productos disponibles",
			NO_DISPONIBLE: "Productos no disponibles",
			INGREDIENTE: "Productos como ingredientes",
			ERROR_RECETA: "Productos con recetas con errores",
			SIN_INGREDIENTES: "Productos con recetas sin ingredientes",
			TODOS: "Todos los productos",
		};
		return labels[value] || "Sin filtro";
	};

	const getCategoriaFiltroLabel = () => {
		if (String(filtro.categoria) === "0") return "Todas las categorías";
		const categoria = categorias.find((item) => String(item.id) === String(filtro.categoria));
		return categoria?.categoria || `ID ${filtro.categoria}`;
	};

	const getProductosFiltradosParaExportar = async () => {
		const limit = 200;
		let currentPage = 1;
		let totalPages = 1;
		const productos = [];

		while (currentPage <= totalPages) {
			const { data: exportData } = await client.query({
				query: GET_PRODUCTOS,
				variables: {
					...variablesFiltroProductos,
					pagination: { page: currentPage, limit },
				},
				fetchPolicy: "network-only",
			});

			const pageProductos = exportData?.productos || [];
			productos.push(...pageProductos);
			totalPages = exportData?.paginationInfo?.pages || 1;
			currentPage += 1;
		}

		return productos;
	};

	const descargarProductosExcel = async () => {
		try {
			setLoadingExport(true);
			const XLSX = require("xlsx");
			const productos = await getProductosFiltradosParaExportar();

			if (!productos.length) {
				handleSnackbar("No hay productos para exportar con los filtros actuales", "info");
				return;
			}

			const fechaGeneracion = new Date();
			const wsData = [];

			wsData.push(["Reporte de productos"]);
			wsData.push([`Fecha de generación: ${fechaGeneracion.toLocaleString("es-AR")}`]);
			wsData.push([
				`Filtro utilizado: Búsqueda="${search || "Sin búsqueda"}" | Categoría="${getCategoriaFiltroLabel()}" | Disponibilidad="${getDisponibilidadLabel(filtro.disponibilidad)}"`,
			]);
			wsData.push([]);
			wsData.push([
				"ID",
				"Nombre",
				"Categoría",
				"Tipo de elaboración",
				"Precio Carta",
				"Precio para Llevar",
				"Costo unitario",
			]);

			productos.forEach((item) => {
				wsData.push([
					item?.id ?? "",
					item?.nombre ?? "",
					item?.categoriaProducto?.categoria ?? "-",
					item?.esElaborado ? "SI" : "NO",
					Number(item?.precioCarta || 0),
					Number(item?.precioOnline || 0),
					Number(item?.precioCosto || 0),
				]);
			});

			const ws = XLSX.utils.aoa_to_sheet(wsData);

			ws["!merges"] = [
				{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } },
				{ s: { r: 1, c: 0 }, e: { r: 1, c: 6 } },
				{ s: { r: 2, c: 0 }, e: { r: 2, c: 6 } },
			];

			for (let col = 0; col <= 6; col += 1) {
				const headerCell = XLSX.utils.encode_cell({ r: 4, c: col });
				if (ws[headerCell]) {
					ws[headerCell].s = {
						font: { name: "Calibri", bold: true },
						fill: { fgColor: { rgb: "D9E1F2" } },
						alignment: { horizontal: "center" },
					};
				}
			}

			for (let row = 5; row < wsData.length; row += 1) {
				[4, 5, 6].forEach((col) => {
					const cell = XLSX.utils.encode_cell({ r: row, c: col });
					if (ws[cell]) ws[cell].z = '"$"#,##0.00';
				});
			}

			ws["!cols"] = [
				{ wch: 10 },
				{ wch: 45 },
				{ wch: 28 },
				{ wch: 22 },
				{ wch: 18 },
				{ wch: 20 },
				{ wch: 18 },
			];

			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "Productos");
			XLSX.writeFile(wb, `Productos_${fechaGeneracion.toISOString().slice(0, 10)}.xlsx`);
			handleSnackbar(`Excel generado con ${productos.length} productos`, "success");
		} catch (err) {
			handleSnackbar("Error al generar el archivo Excel", "error");
		} finally {
			setLoadingExport(false);
		}
	};

	const allRows = useMemo(() => {
		if (data) {
			return getRows(data.productos, (e, item) =>
				menu({
					open: e.currentTarget,
					align: "right",
					options: [
						{
							name: item.disponibilidad ? "Cambiar a no disponible" : "Cambiar a disponible",
							icon: {
								icon: item.disponibilidad ? "arrow_downward" : "arrow_upward",
								color: item.disponibilidad ? getUproColor("uproPink") : getUproColor("uproGreen"),
							},
							onClick: () => {
								item.disponibilidad
									? ejecutarAccionUsuario("noDisponible", item)
									: ejecutarAccionUsuario("disponible", item);
							},
						},
						{
							name: "Descargar Receta en Excel",
							icon: {
								icon: "download",
								color: getUproColor("uproGreen"),
							},
							onClick: () => {
								descargarReceta(item);
							},
						},
						{
							name: "Administrar fotos",
							icon: {
								icon: item.files?.length > 0 ? "photo_camera" : "add_a_photo",
								color:
									item.files?.length > 0 ? getUproColor("uproYellow") : getUproColor("uproGreen"),
							},
							onClick: () => {
								ejecutarAccionUsuario("fotos", item);
							},
						},
						!item.combo && {
							name: "Ver información nutricional",
							icon: {
								icon: "category",
								color: getUproColor("uproGreen"),
							},
							onClick: () => {
								setSelectedProducto(item);
								setOpenInformacionNutricional(true);
							},
						},
						{
							name: "Controles de calidad",
							icon: {
								icon: "verified",
								color: getUproColor("uproBlue"),
							},
							onClick: () => {
								setSelectedProducto(item);
								setOpenControlCalidadHistory(true);
							},
						},
						{
							name: "Editar",
							icon: {
								icon: "edit",
								color: getUproColor("uproYellow"),
							},
							onClick: () => {
								item.combo
									? ejecutarAccionUsuario("editarCombo", item)
									: ejecutarAccionUsuario("editar", item);
							},
						},
						{
							name: "Eliminar",
							icon: {
								icon: "delete",
								color: getUproColor("uproPink"),
							},
							onClick: () => {
								ejecutarAccionUsuario("borrar", item);
							},
						},
						{
							name: "Valoraciones",
							icon: {
								icon: "star_rate",
								color: getUproColor("uproYellow"),
							},
							onClick: () => {
								setSelectedProducto(item);
								setOpenModalValoraciones(true);
							},
						},
					].filter(Boolean),
					handleClose: () => { },
				})
			);
		}
	}, [data, refetch]);

	useEffect(() => {
		if (data?.paginationInfo) setPagesInfo(data.paginationInfo);
	}, [data?.paginationInfo]);

	useEffect(() => {
		if (dataCategorias) {
			setCategorias(dataCategorias.categoriasProducto);
		}
	}, [dataCategorias]);
	useEffect(() => {
		if (dataTipos) {
			setTiposProducto(dataTipos.tiposProducto);
		}
	}, [dataTipos]);

	const [openModalProdComercial, setOpenModalProdComercial] = useState(false);
	const handleOpenModalProdComercial = () => {
		setOpenModalProdComercial(true);
	};
	const handleCloseModalProdComercial = () => {
		setOpenModalProdComercial(false);
	};

	return (
		<GeneralLayout>
			<Card>
				<Grid container spacing={2} p={3}>
					<Grid
						item
						xs={12}
						justifyContent="space-between"
						display="flex"
						sx={{
							flexDirection: {
								xs: "column",
								sm: "row",
							},
						}}
					>
						<SoftBox display="flex" justifyContent="space-between" alignItems="center">
							<SoftTypography variant="h6">
								Comidas y bebidas habilitadas para la carta
							</SoftTypography>
							<SoftBox
								gap={2}
								sx={{
									display: { xs: "flex", sm: "none" },
								}}
							>
								<Tooltip title={"Opciones"} placement="top">
									<SoftButton
										color="primary"
										circular
										iconOnly
										onClick={(event) =>
											menu({
												open: event.currentTarget,
												align: "right",
												options: [
													{
														name: "Orden de Trabajo",
														icon: { icon: "factory", color: getUproColor("uproBlue") },
														onClick: () => {
															setModalOT(true);
														},
													},
													{
														name: "Administrar Categorías",
														icon: { icon: "category", color: getUproColor("uproBlue") },
														onClick: () => {
															setModalCategorias(true);
														},
													},
													// {
													//   name: "Menú del día",
													//   icon: { icon: "menu_book", color: getUproColor("uproGreen") },
													//   onClick: () => {
													//     setModalMenu(true);
													//   },
													// },
													{
														name: "Agregar Producto",
														icon: { icon: "restaurant", color: getUproColor("uproGreen") },
														onClick: () => {
															setModalProducto(true);
														},
													},
													{
														name: "Agregar Combo",
														icon: { icon: "fastfood", color: "primary" },
														onClick: () => {
															setModalCombo(true);
														},
													},
													{
														name: "Descargar Excel",
														icon: { icon: "download", color: getUproColor("uproGreen") },
														onClick: () => {
															descargarProductosExcel();
														},
													},
												],
												handleClose: () => { },
											})
										}
									>
										<Icon>more_vert</Icon>
									</SoftButton>
								</Tooltip>
								{/* <Tooltip
                  title={
                    onlySinIngredientes
                      ? "Mostrar todos los productos"
                      : "Mostrar solo los productos con recetas que tienen ingredientes deshabilitados"
                  }
                  placement="top"
                >
                  <SoftButton
                    color="info"
                    circular
                    iconOnly
                    onClick={() => { setOnlySinIngredientes(false); setMpDisabled(!mpDisabled) }}
                  >
                    <Icon>{mpDisabled ? "error_outline" : "error"}</Icon>
                  </SoftButton>
                </Tooltip> */}
								<Tooltip
									title={openFiltros ? "Ocultar filtros" : "Mostrar filtros"}
									placement="top"
								>
									<SoftButton
										color="uproYellow"
										circular
										iconOnly
										onClick={() => setOpenFiltros(!openFiltros)}
									>
										<Icon>{openFiltros ? "filter_alt_off" : "filter_alt"}</Icon>
									</SoftButton>
								</Tooltip>
								{verificarAcceso(62) && (
									<Tooltip title="Configuracion comanderas" placement="top">
										<SoftButton
											color="info"
											circular
											iconOnly
											onClick={() => setModalComanderas(true)}
										>
											<Icon>print</Icon>
										</SoftButton>
									</Tooltip>)}
							</SoftBox>
						</SoftBox>
						<SoftBox
							display="flex"
							alignItems="center"
							gap={2}
							sx={{
								flexDirection: {
									xs: "column",
									sm: "row",
								},
								mt: { xs: 2, sm: 0 },
							}}
						>
							<SoftBox
								sx={{
									width: { xs: "100%", sm: "auto" },
								}}
							>
								<SoftInput
									placeholder="Escribe aquí..."
									icon={{ component: "search", direction: "left" }}
									onChange={handleSearch}
								/>
							</SoftBox>
							<Tooltip
								title="Administrar ordenes de trabajo"
								placement="top"
								onClick={() => {
									setModalOT(true);
								}}
							>
								<SoftButton
									color="uproYellow"
									circular
									sx={{
										display: { xs: "none", sm: "flex", alignItems: "center" },
									}}
								>
									<Icon>factory</Icon>
									&nbsp;Ordenes de Trabajo
								</SoftButton>
							</Tooltip>
							{/* <Tooltip
                title="Administrar áreas"
                placement="top"
                onClick={() => {
                  setModalAreas(true);
                }}
              >
                <SoftButton
                  color="uproBlue"
                  circular
                  sx={{
                    display: { xs: "none", sm: "flex", alignItems: "center" },
                  }}
                // onClick={() => setModalAreas  (true)}
                >
                  <Icon>category</Icon>
                  &nbsp;Áreas
                </SoftButton>
              </Tooltip> */}
							{/* <Tooltip
                title="Administrar categorías"
                placement="top"
                onClick={() => {
                  setModalCategorias(true);
                }}
              >
                <SoftButton
                  color="uproBlue"
                  circular
                  sx={{
                    display: { xs: "none", sm: "flex" },
                  }}
                >
                  <Icon>category</Icon>
                  &nbsp;Categorías
                </SoftButton>
              </Tooltip> */}
							<Tooltip title="Agregar un producto o un combo" placement="top">
								<SoftButton
									color="primary"
									circular
									sx={{
										display: { xs: "none", sm: "flex" },
									}}
									onClick={() => setModalAddProducto(true)}
								>
									<Icon>add</Icon>
									&nbsp;Agregar
								</SoftButton>
							</Tooltip>
							<Tooltip title="Descargar Excel de productos filtrados" placement="top">
								<SoftButton
									color="uproGreen"
									circular
									iconOnly
									sx={{
										display: { xs: "none", sm: "flex", alignItems: "center" },
									}}
									onClick={descargarProductosExcel}
									disabled={loadingExport}
								>
									{loadingExport ? <Icon>hourglass_top</Icon> : <Icon>download</Icon>}
								</SoftButton>
							</Tooltip>
							{/* <Tooltip
                title={
                  onlySinIngredientes
                    ? "Mostrar todos los productos"
                    : "Mostrar solo los productos con recetas que tienen ingredientes deshabilitados"
                }
                placement="top"
              >
                <SoftButton
                  color="info"
                  circular
                  iconOnly
                  sx={{
                    display: { xs: "none", sm: "flex" },
                  }}
                  onClick={() => { setOnlySinIngredientes(false); setMpDisabled(!mpDisabled) }}
                >
                  <Icon>{mpDisabled ? "error_outline" : "error"}</Icon>
                </SoftButton>
              </Tooltip> */}
							<Tooltip title={openFiltros ? "Ocultar filtros" : "Mostrar filtros"} placement="top">
								<SoftButton
									color="uproYellow"
									circular
									iconOnly
									onClick={() => setOpenFiltros(!openFiltros)}
									sx={{
										display: { xs: "none", sm: "block" },
									}}
								>
									<Icon>{openFiltros ? "filter_alt_off" : "filter_alt"}</Icon>
								</SoftButton>
							</Tooltip>
							{verificarAcceso(62) && (
								<Tooltip title="Configuracion comanderas" placement="top">
									<SoftButton
										color="info"
										circular
										iconOnly
										onClick={() => setModalComanderas(true)}
										sx={{
											display: { xs: "none", sm: "flex" },
										}}
									>
										<Icon>print</Icon>
									</SoftButton>
								</Tooltip>)}
						</SoftBox>
					</Grid>
				</Grid>
				<Collapse in={openFiltros}>
					<SoftBox
						display="flex"
						flexDirection={{
							xs: "column",
							sm: "row",
						}}
						justifyContent="end"
						alignItems="center"
						px={3}
						pb={3}
						gap={2}
					>
						<SoftBox>
							<Select
								value={filtro.categoria}
								onChange={(e) => {
									setPage(1);
									setFiltro({ type: "categoria", payload: e.target.value });
								}}
							>
								<MenuItem value="0">Todas las categorías</MenuItem>
								{categorias.map((categoria) => (
									<MenuItem key={categoria.id} value={categoria.id}>
										{categoria.categoria}
									</MenuItem>
								))}
							</Select>
						</SoftBox>
						<SoftBox>
							<Select
								value={filtro.disponibilidad}
								onChange={(e) => {
									setPage(1);
									setFiltro({ type: "disponibilidad", payload: e.target.value });
								}}
							>
								<MenuItem value={"DISPONIBLE"}>Productos disponibles</MenuItem>
								<MenuItem value={"NO_DISPONIBLE"}>Productos No disponibles</MenuItem>
								<MenuItem value={"INGREDIENTE"}>Productos como ingredientes</MenuItem>
								<MenuItem value={"ERROR_RECETA"}>Productos con recetas con errores</MenuItem>
								<MenuItem value={"SIN_INGREDIENTES"}>
									Productos con recetas sin ingredientes
								</MenuItem>
								<MenuItem value={"TODOS"}>Todos los productos</MenuItem>
							</Select>
						</SoftBox>
					</SoftBox>
				</Collapse>
				<SoftBox>
					{loading || loadingMutation || networkStatus === NetworkStatus.refetch ? (
						<Loading />
					) : error ? (
						<CartelError />
					) : allRows?.length > 0 ? (
						<DataTable columns={columns} rows={allRows} order={orderBy} setOrder={handleOrderBy} />
					) : (
						<SinDatos />
					)}
				</SoftBox>
				<CustomPagination
					loading={loading}
					length={data?.productos?.length}
					total={pagesInfo?.total}
					pages={pagesInfo?.pages}
					page={page}
					setPage={setPage}
					noCard
				/>
			</Card>
			<ModalProducto
				refetch={refetch}
				refetchTipos={refetchTipos}
				selectedProducto={selectedProducto}
				open={modalProducto}
				optionsCreate={optionsCreate}
				handleClose={() => {
					setSelectedProducto(null);
					setModalProducto(false);
					setOptionsCreate({});
				}}
				categorias={categorias}
				tiposProducto={tiposProducto}
			/>
			<ModalNewProducto
				open={modalAddProducto}
				handleClose={() => setModalAddProducto(false)}
				openModalProducto={() => setModalProducto(true)}
				openModalComercial={() => setOpenModalProdComercial(true)}
				optionsCreate={setOptionsCreate}
			/>
			<ModalCombo
				refetch={refetch}
				open={modalCombo}
				handleClose={() => {
					setModalCombo(false);
					setSelectedProducto(null);
				}}
				categorias={categorias}
				tiposProducto={tiposProducto}
				selectedProducto={selectedProducto}
			/>
			<ModalProductoComercial
				refetch={refetch}
				open={openModalProdComercial}
				selectedItem={null}
				handleClose={() => {
					setOpenModalProdComercial(false);
					setSelectedProducto(null);
				}}
				categorias={categorias}
			/>

			<ModalCategorias
				refetch={refetch}
				open={modalCategorias}
				handleClose={() => {
					setModalCategorias(false);
				}}
				refetchCategorias={refetchCategorias}
			/>
			<ModalOrdenesTrabajo
				refetch={refetch}
				open={modalOT}
				handleClose={() => {
					setModalOT(false);
				}}
			/>
			<ModalFotos
				open={modalFotos}
				handleClose={() => {
					setSelectedProducto(null);
					setModalFotos(false);
				}}
				refetch={refetch}
				selectedProducto={selectedProducto}
			/>
			{/* <ModalMenuDelDia
        open={modalMenu}
        handleClose={() => {
          setModalMenu(false);
        }}
      /> */}
			<ModalInformacionNutricional
				open={openInformacionNutricional}
				handleClose={() => {
					setOpenInformacionNutricional(false);
				}}
				idProducto={selectedProducto?.id}
			/>
			<ModalHistorialControlCalidad
				open={openControlCalidadHistory}
				handleClose={() => {
					setOpenControlCalidadHistory(false);
				}}
				idProducto={selectedProducto?.id}
			/>
			{/* <ModalDescuentos
        open={openDescuentos}
        handleClose={() => {
          setOpenDescuentos(false);
        }}
      /> */}
			<ModalValoraciones
				open={openModalValoraciones}
				handleClose={() => {
					setOpenModalValoraciones(false);
				}}
				idProducto={selectedProducto?.id}
				promedioTotal={selectedProducto?.valoracionPromedio || 0}
				producto={selectedProducto}
			/>
			<ModalAreas
				open={modalAreas}
				handleClose={() => {
					setModalAreas(false);
				}}
			/>
			<ModalComanderas
				open={modalComanderas}
				handleClose={() => {
					setModalComanderas(false);
				}}
			/>
		</GeneralLayout>
	);
}

export default Productos;


